// plugins.js (fixed order: jQuery global first, then plugins)

// Non–jQuery utilities (safe to import as ES modules)
import "../../modules/modernizr-custom.js";
import "jquery-nice-select/css/nice-select.css";
import "parallax-js";
import "maplace-js";

import "wowjs";
window.WOW = require('wowjs').WOW;

// Now load all plugins that expect a global jQuery via require(),
// so they run only after window.jQuery has been set.
require("popper.js");
require("bootstrap");
require("slick-carousel");
require("isotope-layout");
require("imagesloaded");
require("lightcase");
require("counterup/jquery.counterup.js");
require("jquery-countdown");
require("waypoints/src/waypoint.js");
require("jquery-nice-select");
require("jquery-validation");
require("jquery.scrollup/dist/jquery.scrollUp.js");
require("jquery-easing");
require("../../modules/jquery-ui-1.14.1.custom/jquery-ui.js");

/*
If/when you re-enable EditorJS, you can keep these as imports
because they don't depend on global jQuery:

// import '@editorjs/table';
// import '@editorjs/list';
// import '@editorjs/warning';
// import '@editorjs/link';
// import '@editorjs/quote';
// import '@editorjs/marker';
// import '@editorjs/checklist';
// import '@editorjs/delimiter';
// import '@editorjs/simple-image';

// import EditorJS from '@editorjs/editorjs';
// window.EditorJS = EditorJS;
*/

